module.exports = __webpack_public_path__ + "media/svg/mn-5d695f22.svg";